export default function () {
    $('body').on('click', '.entry-meta-single .herald-comments a, .herald-comment-action', function(e) {

        e.preventDefault();
        var section = $(this).closest('.herald-section');

        var target = this.hash,
            $target = section.find(target);


        section.find('.herald-comment-form-open').parent().hide();
        section.find('#respond').show();


        $('html, body').stop().animate({
            'scrollTop': $target.offset().top
        }, 900, 'swing', function() {
            window.location.hash = target;
        });

    });
}
